/** Tab keys are also URL values (`?tab=members`), so they are part of the page contract. */
export const ROLE_TABS = {
  permissions: 'permissions',
  members: 'members',
  activity: 'activity',
} as const;

export type RoleTabKey = (typeof ROLE_TABS)[keyof typeof ROLE_TABS];

/** Which role-level dialog the board currently has open, if any. */
export type RoleDialogState = { kind: 'new' | 'duplicate' | 'delete' | 'rename' } | null;

export const isOwnerRole = (role: { systemKey: string | null }) => role.systemKey === 'Owner';
